/* @flow weak */
import React from 'react';
import { DateTimePicker as ReactDateTimePicker } from 'lib/ReactWidgets';
import DateTimePickerMixin from './mixins/DateTimePickerMixin';
import Glyph from 'components/Glyph.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import { datePopups as popups } from 'react-widgets/lib/util/constants';
import createChainedFunction from 'utils/createChainedFunction';
import cx from 'classnames';
import './styles/TimePickerInput.scss';

const TimePickerInput = React.createClass({
  propTypes: {
    value: React.PropTypes.instanceOf(Date),
    min: React.PropTypes.instanceOf(Date),
    max: React.PropTypes.instanceOf(Date),
    placeholder: React.PropTypes.string,
    className: React.PropTypes.string,
    onChange: React.PropTypes.func,
    placement: React.PropTypes.oneOf(['top', 'bottom']),
    disabled: React.PropTypes.bool,
    'data-test': React.PropTypes.string,
  },

  mixins: [
    DateTimePickerMixin,
  ],

  statics: {
    propClasses: {
      placement: {
        top: 'DateTimePicker-top',
        bottom: 'DateTimePicker-bottom',
      },
    },
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
    };
  },

  onClick(event) {
    if (!this.props.disabled) {
      this.handleClick(event);
    }
  },

  render() {
    const open = this.isOpen() ? popups.TIME : false;
    const { value, min, max, placeholder, className, disabled, onFocus, onChange } = this.props;
    const timePickerClass = cx('TimePickerInput', 'DateTimePicker', className, {
      'is-focused': this.isFocused(),
    });
    return (
      <div
        className={cx(timePickerClass, getPropClassesFromInstance(this), {
          'TimePickerInput-disabled': disabled,
        })}
        onClick={this.onClick}>
        <Glyph name="clock" size="medium" color="eclipse" />
        <ReactDateTimePicker
          data-test={this.props['data-test']}
          ref="picker"
          value={value}
          min={min}
          max={max}
          placeholder={placeholder}
          open={open}
          format="h:mm tt"
          parse={['h:mm tt', 'h:mmtt', 'HH:mm']}
          step={5}
          duration={0}
          onFocus={createChainedFunction(this.handleFocus, onFocus)}
          onBlur={this.handleBlur}
          onKeyDown={this.closePopup}
          onChange={createChainedFunction(this.handleChange, onChange)}
          onToggle={() => {}}
          className={cx({
            'TimePickerInput-disabled': disabled,
          })}
        />
      </div>
    );
  },
});

export default TimePickerInput;



// WEBPACK FOOTER //
// ./src/components/TimePickerInput.jsx